export const PHONE_DISPLAY = "+91 82 59 01 01 01";
export const PHONE_TEL = "tel:+918259010101";
export const PHONE_COPY = "+918259010101";
export const WHATSAPP_URL =
  "https://wa.me/918259010101?text=Hello%20TSCM%20Services%2C%20I%27d%20like%20to%20request%20an%20inspection.";
export const EMAIL = "info@tscmservices.in";
